import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IThirdPartySearchCompany } from '@ruby/modules/third-party/models/third-party.interface';
import { selectThirdPartyCompaniesWithCoreState } from '@ruby/modules/third-party/store';
import { fromThirdPartyCompanies, ThirdPartyCompaniesActions } from '@ruby/modules/third-party/store/third-party-companies.index';
import { fromThirdPartyCore } from '@ruby/modules/third-party/store/third-party-core.index';
import { fromThirdPartyStepper } from '@ruby/modules/third-party/store/third-party-stepper.index';
import { IError } from '@ruby/shared/models/request/error.interface';

@Component({
  selector: 'ng-select-company-provider-container',
  template: `
    <ng-select-company-provider
      *ngIf="(store$ | async) as store"
      [companyProviders]="store.companies.companies"
      [error]="store.companies.error"
      [isLoading]="store.companies.loading"
      [contract]="store.core.loa"
      [isEdit]="store.stepper.isEdit"
      [providerCompany]="store.companies.providerCompany"
      (search)="searchCompany($event)"
      (clear)="clear()"
      (selectCompanyProvider)="selectCompanyProvider($event)"
    >
    </ng-select-company-provider>
  `
})
export class SelectCompanyProviderContainerComponent {
  loading!: boolean;
  error?: IError;
  companies!: Array<IThirdPartySearchCompany>;
  store$: Observable<{ core: fromThirdPartyCore.State; companies: fromThirdPartyCompanies.State; stepper: fromThirdPartyStepper.State }>;

  constructor(private store: Store<fromThirdPartyCompanies.State>) {
    this.store$ = this.store.select(selectThirdPartyCompaniesWithCoreState);
  }

  /**
   * Search Company
   *
   * @summary The following method dispatch a set action for companies
   * @param $query: string
   * @returns void
   */
  searchCompany($query: string): void {
    this.store.dispatch(ThirdPartyCompaniesActions.searchCompanies({ data: $query }));
  }

  /**
   * Select Company Provider
   *
   * @summary The following method dispatch an action to select the company provider
   * @param $company: IThirdPartySearchCompany
   * @returns void
   */
  selectCompanyProvider($company: IThirdPartySearchCompany): void {
    this.store.dispatch(ThirdPartyCompaniesActions.setCompanyProvider({ data: $company }));
  }

  /**
   * Clear
   *
   * @summary The following method dispatch an action to clear the company provider
   * @returns void
   */
  clear(): void {
    this.store.dispatch(ThirdPartyCompaniesActions.clearSearch());
  }
}
